import React, { useEffect, useState } from "react";
import { Badge, Button, Form, Alert } from "react-bootstrap";
import { listBookings, raiseDispute } from "../services/partnerAuthService";

const getErr = (err, fallback) => err.response?.data?.error || fallback;
const TONE = { PendingPayment: "warning", Confirmed: "success", Cancelled: "danger" };
const REASONS = [
  { value: "ServiceNotProvided", label: "Service not provided" },
  { value: "WrongService", label: "Wrong service" },
  { value: "PartnerIssue", label: "Partner issue" },
  { value: "RefundIssue", label: "Refund issue" },
  { value: "Other", label: "Other" },
];

export default function Bookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [disputeFor, setDisputeFor] = useState(null);
  const [reason, setReason] = useState(REASONS[0].value);
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const load = () => {
    setLoading(true);
    listBookings()
      .then(({ data }) => setBookings(data.data || []))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const openDisputeForm = (booking) => {
    setDisputeFor(booking);
    setReason(REASONS[0].value);
    setDescription("");
    setError("");
    setSuccess("");
  };

  const handleRaiseDispute = async (e) => {
    e.preventDefault();
    setError(""); setSuccess("");
    setSubmitting(true);
    try {
      await raiseDispute(disputeFor._id, { reason, description });
      setSuccess("Dispute raised. Our team will review it shortly.");
      setDisputeFor(null);
    } catch (err) {
      setError(getErr(err, "Unable to raise dispute"));
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <p>Loading bookings…</p>;

  return (
    <div>
      <h4 className="mb-3">Bookings</h4>
      {success && <Alert variant="success">{success}</Alert>}
      {bookings.length === 0 ? (
        <div className="partner-card partner-empty">No bookings yet.</div>
      ) : (
        <div className="d-flex flex-column gap-3">
          {bookings.map((b) => (
            <div key={b._id} className="partner-card d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div>
                <h6 className="mb-1">{b.travelRequestId?.destination || "Trip"}</h6>
                <small className="text-muted">Gross ₹{b.grossAmount} · Payable to you ₹{b.partnerPayable}</small>
              </div>
              <div className="d-flex align-items-center gap-2">
                <Badge bg={TONE[b.status] || "secondary"}>{b.status}</Badge>
                <Button size="sm" variant="outline-secondary" onClick={() => openDisputeForm(b)}>Raise Dispute</Button>
              </div>
            </div>
          ))}
        </div>
      )}

      {disputeFor && (
        <div className="partner-card mt-4">
          <h5>Raise a Dispute — {disputeFor.travelRequestId?.destination || "Trip"}</h5>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleRaiseDispute}>
            <Form.Group className="mb-2">
              <Form.Label>Reason</Form.Label>
              <Form.Select value={reason} onChange={(e) => setReason(e.target.value)}>
                {REASONS.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={3} value={description} onChange={(e) => setDescription(e.target.value)} />
            </Form.Group>
            <div className="d-flex gap-2">
              <Button type="submit" disabled={submitting}>{submitting ? "Submitting…" : "Submit Dispute"}</Button>
              <Button variant="outline-secondary" onClick={() => setDisputeFor(null)}>Cancel</Button>
            </div>
          </Form>
        </div>
      )}
    </div>
  );
}
